import { Link as ChakraLink, Text } from '@chakra-ui/react'
import { Ellipsis } from 'brokertslib/src/components'
import { Link as ReactRouterLink } from 'react-router-dom'

import { useAuth } from '../../context/AuthContext'

export const OrganizationLink = ({ id, name, sx, showId = false }:
{ id?: number, name?: string, sx?: {}, showId?: boolean }) => {
  const auth = useAuth()

  const to = auth?.user?.ouId === id ? '/organization' : `/organization/${id}`

  return (
    <ChakraLink as={ReactRouterLink} to={to}>
      <Ellipsis as='span' tooltipProps={{ boxProps: { as: 'span' } }} sx={sx}>
        <Text as='span'>{name}{showId && id && `, Id: ${id}`}</Text>
      </Ellipsis>
    </ChakraLink>
  )
}

export const OrganizationLinkPlain = ({ id, name, sx, showId = false }:
{ id?: number, name?: string, sx?: {}, showId?: boolean }) => {
  const auth = useAuth()

  const to = auth?.user?.ouId === id ? '/organization' : `/organization/${id}`

  return (
    <ChakraLink as={ReactRouterLink} to={to} sx={sx}>
      {name}{showId && id && `, Id: ${id}`}
    </ChakraLink>
  )
}